import { useState } from "react";
import axios from "axios";
import { formatApiError } from "@/lib/auth";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Per-game in-memory cache so re-opening a preview is instant.
const cache = new Map();

function keyFor(game) {
  return [
    (game.sport || "").toLowerCase(),
    (game.home_team || "").toLowerCase(),
    (game.away_team || "").toLowerCase(),
    (game.date || "tbd").toLowerCase().slice(0, 10),
  ].join("|");
}

export function useGamePreview() {
  const [state, setState] = useState({}); // gameKey -> { loading, text, error }

  async function load(game) {
    const k = keyFor(game);
    if (state[k]?.text) return state[k].text;
    if (cache.has(k)) {
      const text = cache.get(k);
      setState((s) => ({ ...s, [k]: { loading: false, text } }));
      return text;
    }
    setState((s) => ({ ...s, [k]: { loading: true } }));
    try {
      const r = await axios.post(`${API}/games/preview`, {
        sport: game.sport,
        home_team: game.home_team,
        away_team: game.away_team,
        date: game.date || null,
        time: game.time || null,
        platforms: game.platforms || [],
      }, { timeout: 45000 });
      const text = r.data?.preview || "";
      cache.set(k, text);
      setState((s) => ({ ...s, [k]: { loading: false, text } }));
      return text;
    } catch (err) {
      const msg = formatApiError(err) || "Could not load preview.";
      setState((s) => ({ ...s, [k]: { loading: false, error: msg } }));
      return null;
    }
  }

  function getFor(game) {
    return state[keyFor(game)] || {};
  }

  return { load, getFor };
}
